import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import { dateTimeFormat } from "../../util/DateUtil";
import { Typography } from "@mui/material";

const useStyles = makeStyles({
  paper: {
    marginTop: "20px",
    paddingBottom: "20px",
  },
  title: {
    paddingTop: "20px;",
    paddingBottom: "20px;",
  },
  rowNotSelected: {
    cursor: "pointer",
  },
  rowSelected: {
    cursor: "pointer",
    backgroundColor: "#b5e7a4",
  },
  cursorLink: {
    cursor: "pointer",
  },
  loading: {
    marginRight: "10px",
    marginLeft: "10px",
  },
});

export default function NotaBimestreTableV2({ listNotaBimestre }) {
  const classes = useStyles();

  return (
    <div style={{ backgroundColor: "#f7cac9", padding: 5 }}>
      <Grid container className={classes.title} justifycontent="space-between">
        <Grid size={5}>
          <Typography variant="h5">Nota Bimestre</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={3}></Grid>

      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Cód. Disciplina</TableCell>
            <TableCell>Descrição Disciplina</TableCell>
            <TableCell>Nota</TableCell>
            <TableCell>Criado em</TableCell>
            <TableCell>Última Atualização</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {listNotaBimestre && listNotaBimestre.length > 0
            ? listNotaBimestre.map((nb) => (
                <TableRow key={nb.codigo}>
                  <TableCell>{nb?.tdp?.disciplina?.codDisciplina}</TableCell>
                  <TableCell>{nb?.tdp?.disciplina?.descricao}</TableCell>
                  <TableCell>{nb?.nota}</TableCell>
                  <TableCell>{dateTimeFormat(nb?.createdAt)}</TableCell>
                  <TableCell>{dateTimeFormat(nb?.lastModified)}</TableCell>
                </TableRow>
              ))
            : ""}
        </TableBody>
      </Table>
    </div>
  );
}
